(function ($) {
    $(window).on('load', function () {

		/* Burger menu mobile trigger */
		$('#nav-mobile-button').on('click', function(){
			$('body').toggleClass('no-scroll'); // Disable background scroll when mobile menu is open
			$(this).toggleClass('open');
			$('#navigation-primary').toggleClass('open');
		});

		/* Sub-menu mobile trigger */
		function clickable_submenus() {
			let top_level_link = '#menu-menu-principal .menu-item-has-children > a';
			let parent_items = '#menu-menu-principal .menu-item-has-children';

			// Keep one toggle icon only
			$(top_level_link).each(function () {
				if (!$(this).next('i').length) {
					$(this).after('<i></i>');
				}
				$(this).nextAll('.sub-menu').first().addClass('hide');
			});

			// Make the whole parent <li> clickable on mobile to toggle submenu
			$(parent_items).on('click', function (event) {
				if (window.matchMedia('(min-width: 992px)').matches) return;
				if ($(event.target).closest('.sub-menu a').length) return;

				event.preventDefault();

				const $item = $(this);
				const $submenu = $item.children('.sub-menu').first();

				$item.toggleClass('open');
				$submenu.toggleClass('hide', 1000);
			});
		}
		setTimeout(function () { clickable_submenus(); }, 300);

		function scrollFunction() {
			if (document.body.scrollTop > 80 || document.documentElement.scrollTop > 80) {
				$("header").addClass('scrolled');
			} else {
				$("header").removeClass('scrolled');
			}
		}
		window.onscroll = function() { scrollFunction() };

    });
})(jQuery);
